"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var styles_1 = require("@mui/material/styles");
var material_1 = require("@mui/material");
exports.Component = (0, styles_1.styled)(material_1.Switch, {
    shouldForwardProp: function (prop) { return prop !== 'icons' && prop !== 'multistate' && prop !== 'disabled'; },
})(function (_a) {
    var theme = _a.theme, icons = _a.icons, multistate = _a.multistate, disabled = _a.disabled;
    return ({
        width: 62,
        height: 34,
        padding: 7,
        '& .MuiSwitch-switchBase': {
            margin: 1,
            padding: 0,
            transform: 'translateX(6px)',
            '&.Mui-checked': {
                color: theme.palette.background.default,
                transform: 'translateX(22px)',
                '& .MuiSwitch-thumb:before': {
                    backgroundImage: icons.on,
                },
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: disabled ? '#f5f5f5' : theme.palette.primary.main,
                },
            },
        },
        '& .MuiSwitch-thumb': {
            backgroundColor: disabled ? '#f5f5f5' : theme.palette.background.default,
            width: 32,
            height: 32,
            '&:before': {
                content: "''",
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: icons.off,
            },
        },
        '& .MuiSwitch-track': {
            opacity: 1,
            borderRadius: 20 / 2,
            backgroundColor: disabled
                ? '#f5f5f5'
                : multistate
                    ? theme.palette.grey[400]
                    : theme.palette.primary.main,
        },
    });
});
